import React from "react";
import { view } from "react-easy-state";
import { withRouter } from "react-router-dom";
import { Radio, Button, message, Icon } from "antd";
import MathJax from "react-mathjax-preview";

// import InnerHtml from 'components/common/InnerHtml'

import globalStore from "store";

import QuestionsService from "services/students/questions.service";
import AskDoubt from "components/pages/students/AskDoubt";

class QuestionView extends React.Component {
  handleOptionChange = (e, selectedOptionIndices) => {
    const pageState = globalStore.ui.students.questions.show;
    pageState.selectedOptionIndices = [selectedOptionIndices];
  };

  handleCheckAnswer = async (questionType) => {
    const pageState = globalStore.ui.students.questions.show;
    const { selectedOptionIndices } = pageState;

    if (questionType !== "subjective" && selectedOptionIndices.length < 1) {
      message.destroy();
      message.error("Please select atleast one option to continue");
      return;
    }

    pageState.checkAnswerLoading = true;

    const { questionId, chapterId, questionnaireId } = this.props.match.params;

    await QuestionsService.answer({
      pageState,
      questionId,
      chapterId,
      questionnaireId,
      selectedOptionIndices,
    });

    pageState.checkAnswerLoading = false;
  };

  handleNextQuestion = () => {
    const { chapterId, questionnaireId } = this.props.match.params;
    const pageState = globalStore.ui.students.questions.show;
    pageState.selectedOptionIndices = [];
    delete pageState.API_QUESTIONS_ANSWER_STATUS;
    this.props.history.push(
      `/chapters/${chapterId}/questionnaires/${questionnaireId}/start-${pageState.question.qtype}`
    );
  };

  renderOptionIcon = (index) => {
    const pageState = globalStore.ui.students.questions.show;
    const {
      API_QUESTIONS_ANSWER_STATUS,
      selectedOptionIndices,
      checkAnswerLoading,
    } = pageState;

    const { question } = this.props;

    if (
      !API_QUESTIONS_ANSWER_STATUS ||
      API_QUESTIONS_ANSWER_STATUS !== "fulfilled"
    ) {
      return (
        <Radio
          style={{ marginRight: 10 }}
          disabled={checkAnswerLoading}
          checked={
            selectedOptionIndices && selectedOptionIndices.includes(index)
          }
          onChange={(e) => this.handleOptionChange(e, index)}
        />
      );
    }

    if (question.correct_option_index === index) {
      return (
        <div className="option-icon correct-option">
          <Icon type="check" />
        </div>
      );
    }

    if (selectedOptionIndices && selectedOptionIndices.includes(index)) {
      return (
        <div className="option-icon wrong-option">
          <Icon type="close" />
        </div>
      );
    }

    return <div className="option-icon"></div>;
  };

  render() {
    const { match } = this.props;
    const pageState = globalStore.ui.students.questions.show;
    const {
      questionnaire_attempt,
      API_QUESTIONS_ANSWER_STATUS,
      checkAnswerLoading,
    } = pageState;

    const answerSubmitted =
      API_QUESTIONS_ANSWER_STATUS &&
      API_QUESTIONS_ANSWER_STATUS === "fulfilled";
    const { question } = this.props;

    const attemptedQuestionsCount =
      question.qtype === "subjective"
        ? questionnaire_attempt.attempted_subjective_questions_count + 1
        : questionnaire_attempt.attempted_questions_count -
          questionnaire_attempt.attempted_subjective_questions_count +
          1;
    const totalQuestionsCount =
      question.qtype === "subjective"
        ? questionnaire_attempt.total_questions_count -
          questionnaire_attempt.total_objective_questions_count
        : questionnaire_attempt.total_objective_questions_count;

    return (
      <div className="lecture-question-view">
        <div className="lecture-question-content">
          <div style={{ color: "gray", marginBottom: 20 }}>
            Question {attemptedQuestionsCount} of {totalQuestionsCount}
          </div>
          <h3>
            <MathJax math={question.question} />
          </h3>
          {question.qtype === "objective" && (
            <div className="question-options">
              {question.options.map((o, index) => {
                return (
                  <div key={index} className="question-option">
                    <label>
                      {this.renderOptionIcon(index)}
                      <span>{o}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          )}
          {answerSubmitted && (
            <div className="question-note">
              <h3>Explanation</h3>
              {question.explanation ? (
                <MathJax math={question.explanation} />
              ) : (
                "No explanation found"
              )}
            </div>
          )}
          <div className="question-actions">
            <div className="left-btns">
              <AskDoubt
                questionId={question.id}
                chapterId={match.params.chapterId}
                hideSubjectInput={true}
                buttonStyle={{
                  position: "initial",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              />
            </div>
            <div className="right-btns">
              {!answerSubmitted && question.qtype === "objective" && (
                <Button
                  type="primary"
                  loading={checkAnswerLoading}
                  onClick={this.handleCheckAnswer}
                >
                  Check Answer
                </Button>
              )}
              {!answerSubmitted && question.qtype === "subjective" && (
                <Button
                  type="primary"
                  loading={checkAnswerLoading}
                  onClick={() => this.handleCheckAnswer("subjective")}
                >
                  View Explanation
                </Button>
              )}
              <Button
                disabled={checkAnswerLoading || !answerSubmitted}
                onClick={this.handleNextQuestion}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(view(QuestionView));
